/**
 * La Bascule — bandeau d'alerte « occasion exceptionnelle ».
 *
 * Posé par le moteur (tirage rare, indifférent à l'état du pays). OPT-IN : tant
 * que le joueur ne clique pas « La saisir », rien ne se déclenche ; ignorer la
 * laisse expirer. Saisir ouvre une décision à double tranchant (un pari, pas un
 * buff) — voir `seizeOpportunity` dans le store.
 */

import { useGame } from "../store/useGame";

export function OpportunityBanner() {
  const opportunity = useGame((s) => s.availableOpportunity);
  const seize = useGame((s) => s.seizeOpportunity);

  if (!opportunity) return null;

  return (
    <div className="opportunity-banner" role="alert">
      <span className="opportunity-banner-label">
        ✦ Une occasion exceptionnelle se présente
      </span>
      <button
        type="button"
        className="opportunity-banner-cta"
        onClick={() => seize()}
      >
        La saisir →
      </button>
    </div>
  );
}
